<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m10.2 2.7-7 3a2 2 0 0 0-1 1.2 2 2 0 0 0 0 1.5L7 20.3a2 2 0 0 0 1 1 2 2 0 0 0 1.5 0l7-3a2 2 0 0 0 1-1.2q.4-.7 0-1.5L12.8 3.7a2 2 0 0 0-1-1 2 2 0 0 0-1.5 0m5.5-.2q.8 0 1.4.5t.6 1.3V8q0 .4-.3.7a1 1 0 0 1-1.7-.6V4.5h-1l-.6-.3a1 1 0 0 1 .5-1.7zm3 2.6.6-.5h.7q.4 0 .8.3.7.3 1 1t.1 1.5v.1L19.5 13l-.5.5a1 1 0 0 1-1.3-.5v-.8L20 6.7l-.3-.1-.4-.2-.5-.5z"
    />
  </svg>
</template>
